import { createFileRoute } from "@tanstack/react-router";

import { FeaturePage } from "@/components/site/FeaturePage";
import { featurePage } from "@/content/features";
import { normalizeLocale } from "@/lib/i18n";
import { pageHead } from "@/content/seo-pages";
import { faqScript } from "@/lib/faq-schema";

export const Route = createFileRoute("/{-$locale}/production")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const seo = featurePage("production").seo;
    const head = pageHead("/production", locale, { title: seo.title, description: seo.description });
    return { ...head, scripts: faqScript(featurePage("production").faq, locale) };
  },
  component: productionPage,
});

function productionPage() {
  return <FeaturePage content={featurePage("production")} />;
}
